module.exports = __webpack_public_path__ + "img/doctor.5f027c6a.png";